import {ScrollTrigger, gsap} from '../LibrariesImport';
export default class BlockTimeline {
	static init() {
		const timelines = [...document.querySelectorAll('.block-timeline')];

		if (timelines.length === 0) {
			return;
		}

		timelines.forEach((block) => {

			const pin = block.querySelector(".current-year-pin");
			const timeline = block.querySelector(".timeline");
			const currentYear = block.querySelector(".current-year");

			ScrollTrigger.create({
				trigger: timeline,
				start: "top center",
				end: () => `+=${timeline.clientHeight - timeline.clientHeight / 35}`,
				scrub: true,
				anticipatePin: 1,
				pin: pin,
			});
			timeline.querySelectorAll(".timeline-item").forEach(timelineItem => {
				const bigYear = timelineItem.querySelector(".year-big");
				const pillContent = timelineItem.dataset.pillContent || bigYear.textContent;
				gsap.set(bigYear, {opacity: 0});
				const odd = timelineItem.classList.contains("odd");
				const xOffset = odd ? "15px" : "-15px";

				ScrollTrigger.create({
					trigger: timelineItem,
					start: "top center",
					end: "bottom center",
					onEnter: () => {
						gsap.to(bigYear, {opacity: 1});
						gsap.from(bigYear, {x: xOffset});
						currentYear.innerHTML = pillContent;
					},
					onEnterBack: () => {
						gsap.to(bigYear, {opacity: 1});
						gsap.from(bigYear, {x: xOffset});
						currentYear.innerHTML = pillContent;
					},
					onLeave: () => {
						gsap.to(bigYear, {opacity: 0});
					},
					onLeaveBack: () => {
						gsap.to(bigYear, {opacity: 0});
					}
				});
			});
		});
	}
}
